export default __webpack_public_path__ + "static/media/ICON_revista.25dbd6b4.png";